window.Products = {};
window.Products.product_types = {
	1: 'DeviceCase.Iphone4',
	2: 'DeviceCase.Iphone5',
	3: 'DeviceCase.GalaxyS3',
	4: 'DeviceCase.GalaxyS4',
	7: 'Accessory.PencilCase',
	8: 'HomeDecor.PillowCase',
	9: 'DeviceCase.IpadMini',
	11: 'DeviceCase.IpodTouch4',
	12: 'Clothing.Leggings',
	13: 'Scarf.Scarf', // Previously Long Scarf
	14: 'Scarf.SquareScarf',
	15: 'Scarf.BigSquareScarf',
	16: 'Clothing.Capris',
	17: 'Clothing.FittedSkirt',
	18: 'Bag.ToteBag',
	19: 'DeviceCase.GalaxyS5',
	20: 'Clothing.FlareSkirt',
	26: 'DeviceCase.Iphone6',
	27: 'Clothing.BabyLeggings',
		'27-6months': 'Clothing.BabyLeggings6months',
		'27-1year'	: 'Clothing.BabyLeggings1year',
		'27-2years'	: 'Clothing.BabyLeggings2years',
		'27-3years'	: 'Clothing.BabyLeggings3years',
	28: 'DeviceCase.IpadAir',
	29: 'DeviceCase.Ipad2',
	35: 'Clothing.BodyconDress',
	36: 'Clothing.FlareDress',
	37: 'WallArt.ArtProduct',
	38: 'WallArt.ArtPrint',
	39: 'WallArt.Canvas',
	40: 'WallArt.WoodPrint',
	41: 'WallArt.Poster',
	42: 'Clothing.Beanie',
	43: 'Clothing.KimonoRobe',
	44: 'Clothing.DrapedKimono',
	45: 'Accessory.MakeupBag',
	46: 'Clothing.YogaLeggings',
	47: 'Clothing.Shorts',
	50: 'Material.Fabric',
	51: 'DeviceCase.GalaxyS6Edge',
	52: 'DeviceCase.GalaxyS7',
	53: 'DeviceCase.GalaxyS7Edge',
	54: 'DeviceCase.Iphone6Plus',
	55: 'DeviceCase.GalaxyS6',
	56: 'DeviceCase.Iphone7',
	57: 'DeviceCase.Iphone7Plus',
	58: 'Clothing.YogaCapris',
	59: 'Accessory.Headband',
	60: 'Clothing.YouthLeggings',
		'60-4to5years': 'Clothing.YouthLeggings4to5years',
		'60-6to7years': 'Clothing.YouthLeggings6to7years',
		'60-8to9years': 'Clothing.YouthLeggings8to9years',
		'60-10to12years': 'Clothing.YouthLeggings10to12years',
	61: 'Clothing.AthleticCropTop',
	62: 'Clothing.MiniShorts',
	63: 'Bag.DayTote',
	64: 'Clothing.LooseTankTop',
		'64-regular': 'Clothing.LooseTankTopRegular',
		'64-long' 	: 'Clothing.LooseTankTopLong',
	65: 'Clothing.FittedTankTop',
		'65-regular': 'Clothing.FittedTankTopRegular',
		'65-long' 	: 'Clothing.FittedTankTopLong',
	66: 'Book.Notebook',
	67: 'Bag.OrigamiTote',
	68: 'DeviceCase.GalaxyS8',
	69: 'Stationery.StationeryCard',
	70: 'Clothing.Peignoir',
	71: 'Book.SpiralNotebook',
	72: 'DeviceCase.IphoneX',
	73: 'Accessory.ZipperCarryAll',
	75: 'DeviceCase.GalaxyS9',
	76: 'WallArt.AcrylicPrint',
	77: 'Clothing.WrapSkirt',
	78: 'Clothing.CheekyBriefs',
	79: 'Clothing.Boyshorts',
	80: 'Clothing.BoxerBriefs',
	81: 'DeviceCase.IphoneXSMax',
	82: 'DeviceCase.IphoneXR',
	83: 'Clothing.ShirtBellacanvas3001',
	84: 'Clothing.ShirtBellacanvas6004',
	85: 'Clothing.RacerbackTankTop',
	86: 'HomeDecor.DuvetCover',
		'86-twin'	: 'HomeDecor.DuvetCoverTwin',
		'86-full'	: 'HomeDecor.DuvetCoverFull',
		'86-queen'	: 'HomeDecor.DuvetCoverQueen',
		'86-king'	: 'HomeDecor.DuvetCoverKing',
	87: 'HomeDecor.WallTapestry',
	88: 'Clothing.CrewneckSweatshirt',
	89: 'HomeDecor.BedPillowSham',
		'89-standard'	: 'HomeDecor.BedPillowShamStandard',
		'89-king'		: 'HomeDecor.BedPillowShamKing',
	90: 'HomeDecor.BedPillowSleeve',
		'90-standard'	: 'HomeDecor.BedPillowSleeveStandard',
		'90-king'		: 'HomeDecor.BedPillowSleeveKing',
	91: 'Accessory.FaceMask',
	92: 'Accessory.LightweightFaceCovering',
	93: 'Clothing.ShirtMilltex901',
	94: 'HomeDecor.TeaTowel',
	95: 'Bag.MarketTote',
	96: 'Clothing.KangarooHoodie',
	97: 'Clothing.LoungePants',
	98: 'Clothing.ScoopBralette',
	99: 'HomeDecor.HolidayStocking',
	100: 'Clothing.ComfortTShirt',
	101: 'Clothing.PremiumTShirt',
	102: 'Clothing.ComfortSlimfitTShirt',
	103: 'Clothing.PremiumSlimfitTShirt',
	104: 'Clothing.ComfortLongSleeveTShirt',
	105: 'Clothing.PremiumLongSleeveTShirt',
	106: 'Clothing.ComfortRacerbackTankTop',
	107: 'Clothing.PremiumUnisexTankTop',
	108: 'Clothing.FlowRacerbackTankTop',
	109: 'Clothing.ClassicCrewneck',
	110: 'Clothing.PremiumCrewneck',
	111: 'Clothing.ClassicZipperHoodie',
	112: 'Clothing.PremiumZipperHoodie',
	113: 'Clothing.ClassicPulloverHoodie',
	114: 'Clothing.PremiumPulloverHoodie',
	115: 'Clothing.FlowPulloverHoodie',
	116: 'Clothing.CroppedPulloverHoodie',
	117: 'HomeDecor.Blanket',
	118: 'Accessory.VeganLeatherCrossbodyPurse',
	119: 'Accessory.VeganLeatherMakeupBag',
	120: 'Bag.VeganLeatherToteBag',
	121: 'Clothing.YogaShorts',
	122: 'Stationery.PermanentSticker',
	123: 'Bag.VeganLeatherBackpack',
	124: 'Bag.PremiumDrawstringBag',
	125: 'HomeDecor.StainlessSteelTumbler',
	126: 'Clothing.UnisexPoloShirt',
	127: 'Clothing.FittedPoloShirt',
	128: 'Clothing.UnisexJoggers',
	129: 'HomeDecor.DeskMat',
	130: 'HomeDecor.StainlessSteelWaterBottle',
	131: 'HomeDecor.Coaster',
	132: 'HomeDecor.Placemat',
	133: 'HomeDecor.Tablecloth',
	134: "HomeDecor.VeganLeatherPlacemat",
	135: "HomeDecor.PetBowl",
	136: "HomeDecor.AluminumPrint",
	137: 'Bag.DrawstringBag',
	138: 'Accessory.PrintedPatch',
	139: 'Accessory.SnapbackWithPrintedPatch',
	140: 'Accessory.DadCapWithPrintedPatch',
	141: 'Scarf.Scarf',
	144: 'Accessory.RuffleScrunchie',
	200: 'Embroidery.Snapback',
	201: 'Embroidery.DadCap',
};

window.Products.Product = function() {};

window.Products.Product.icon_slug = 'product';
window.Products.Product.dpi = 300;

window.Products.getProduct = function(id) {
	//0 is category, 1 is product
	var ns = this.product_types[id].split('.');

	return new Products[ns[0]][ns[1]]();
};

window.Products.getProductClass = function(id) {
	//0 is category, 1 is product
	var ns = this.product_types[id].split('.');

	return Products[ns[0]][ns[1]];
};

/**
 * Loads a product's json file then calls the given callback
 */
window.Products.Product.prototype.loadData = function(callback) {
	var me = this, i;

	// Just call the callback right now if the data is already in
	var children = me.getChildren();
	var all_loaded = true;

	if(children.length){	
		for(i = 0; i < children.length; i++){
			if(!children[i].static.preview_data){
				all_loaded = false;
				break;
			}
		}
	} else if(!me.static.preview_data){
		all_loaded = false;
	}

	if(all_loaded) {
		if(callback) callback();
		return;
	}

	AOW.request({
		method: 'GET',
		data: { product: me.static.slug },
		url: 'create/product-data',
		success: function(response) {
			try {
				var data = JSON.parse(response.data.json), value;
				// Check if we received one or multiple elements (subproducts)
				if(Array.isArray(data)){
					for(i = 0; i < data.length; i++){
						var child_data = JSON.parse(data[i]);
						var child_id = child_data.id;
						for(value in child_data){
							if(!child_data.hasOwnProperty(value)) continue;

							// Let's only do the preview_data for now
							if(value != 'preview_data' && value != 'options') continue;
							
							window.Products.getProductClass(child_id)[value] = child_data[value];
						}
					}
				} else {
					for(value in data){
						if(!data.hasOwnProperty(value)) continue;
						
						// Let's only do the preview_data for now
						if(value != 'preview_data' && value != 'options' && value != 'mirror_from_center') continue;
						
						window.Products.getProductClass(me.static.id)[value] = data[value];
					}
				}
				if(callback) callback();
			} catch (e) {
				console.log(e); return;
			}
		},
		error: function(response) {
			console.log(response); return;
		}
	});
};

window.Products.Product.prototype.getChildren = function(){
	var children = [];
	for(var typeid in window.Products.product_types){
		try{
			var product = window.Products.getProduct(typeid);
			if(product && product.parent.static.id == this.static.id){
				children.push(product);
			}
		} catch(e){
			continue;
		}
	}
	return children;
};

window.Products.Product.prototype.hasTool = function(tool, preview_data, scene, variant) {
	if(this.static.use_variants)
		return preview_data.scenes[scene].variants[variant].tools.indexOf(tool) >= 0;	
	else
		return preview_data.scenes[scene].tools.indexOf(tool) >= 0;	
};

window.Products.Product.prototype.draw_side = function(ctx, img, data, side) {
	var sideIndex, deltax, deltay, preview_x, preview_y, originalWidth, originalHeight, scaleWidth, scaleHeight;

	//Different deltax and preview_x depending on side
	if(side === 'left') {
	    sideIndex = 0;
	} else {
	    sideIndex = 1;
	}
	
	deltax = (Array.isArray(data.deltax)) ? data.deltax[sideIndex] : data.deltax;
	deltay = (Array.isArray(data.deltay)) ? data.deltay[sideIndex] : data.deltay;
	preview_x = (Array.isArray(data.preview_x)) ? data.preview_x[sideIndex] : data.preview_x;
	preview_y = (Array.isArray(data.preview_y)) ? data.preview_y[sideIndex] : data.preview_y;
	originalWidth = (Array.isArray(data.originalWidth)) ? data.originalWidth[sideIndex] : data.originalWidth;
	originalHeight = (Array.isArray(data.originalHeight)) ? data.originalHeight[sideIndex] : data.originalHeight;
	scaleWidth = (Array.isArray(data.scaleWidth)) ? data.scaleWidth[sideIndex] : data.scaleWidth;
	scaleHeight = (Array.isArray(data.scaleHeight)) ? data.scaleHeight[sideIndex] : data.scaleHeight;

	//crop it in a buffercanvas first if there are crop coords
	if(data.cropWidth > 0) {
		var cropX = (Array.isArray(data.cropX)) ? data.cropX[sideIndex] : data.cropX,
			cropY = (Array.isArray(data.cropY)) ? data.cropY[sideIndex] : data.cropY,
			cropWidth = (Array.isArray(data.cropWidth)) ? data.cropWidth[sideIndex] : data.cropWidth,
			cropHeight = (Array.isArray(data.cropHeight)) ? data.cropHeight[sideIndex] : data.cropHeight;

		var bufferCanvas = document.createElement('canvas');
		bufferCanvas.width = this.static.preview_data.texture_width;
		bufferCanvas.height = this.static.preview_data.texture_height;

		var bufferCtx = bufferCanvas.getContext('2d');
		bufferCtx.drawImage(img, 
			deltax*data.canvasPixelRatio,
			deltay*data.canvasPixelRatio,
			originalWidth*data.canvasPixelRatio,
			originalHeight*data.canvasPixelRatio,
			0,
			0,
			scaleWidth,
			scaleHeight
		);

		ctx.drawImage(bufferCanvas, cropX, cropY, cropWidth, cropHeight, preview_x, preview_y, cropWidth, cropHeight);
	} else {		
		//Draw it
		ctx.drawImage(img, 
			deltax*data.canvasPixelRatio,
			deltay*data.canvasPixelRatio,
			originalWidth*data.canvasPixelRatio,
			originalHeight*data.canvasPixelRatio,
			preview_x,
			preview_y,
			scaleWidth,
			scaleHeight
		);
	}
};

window.Products.Product.prototype.draw_scene = function(ctx, img, data) {
	var x = data.deltax*data.canvasPixelRatio,
		y = data.deltay*data.canvasPixelRatio,
		w = data.originalWidth*data.canvasPixelRatio,
		h = data.originalHeight*data.canvasPixelRatio,
		cropWidth = data.cropWidth ? data.cropWidth : data.scaleWidth,
		cropHeight = data.cropHeight ? data.cropHeight : data.scaleHeight;

	//Draw it
	if(data.preview_r){
		ctx.save();

		var origin = {
				x: 0,
				y: 0
			};

		var a = { x: data.preview_x, y: data.preview_y };
		var b = { x: data.preview_x+cropWidth, y: data.preview_y };
		var c = { x: data.preview_x+cropWidth, y: data.preview_y+cropHeight };
		var d = { x: data.preview_x, y: data.preview_y+cropHeight };
		
		a = Utils.rotatePoint(origin, a, data.preview_r);
		b = Utils.rotatePoint(origin, b, data.preview_r);
		c = Utils.rotatePoint(origin, c, data.preview_r);
		d = Utils.rotatePoint(origin, d, data.preview_r);

		var boundingBox = {
			x: Math.min(a.x,b.x,c.x,d.x),
			y: Math.min(a.y,b.y,c.y,d.y)
		};

		ctx.translate(-boundingBox.x, -boundingBox.y);
		ctx.translate(data.preview_x, data.preview_y);
		ctx.rotate(data.preview_r*Math.PI/180.0);
	}

	//crop it in a buffercanvas first if there are crop coords
	if(data.cropWidth > 0) {
		var bufferCanvas = document.createElement('canvas');
		bufferCanvas.width = this.static.preview_data.texture_width;
		bufferCanvas.height = this.static.preview_data.texture_height;

		var bufferCtx = bufferCanvas.getContext('2d');
		bufferCtx.drawImage(img, x, y, w, h, 0, 0, data.scaleWidth, data.scaleHeight);

		ctx.drawImage(bufferCanvas, data.cropX, data.cropY, data.cropWidth, data.cropHeight, data.preview_x, data.preview_y, data.cropWidth, data.cropHeight);
	} else {		
		ctx.drawImage(img, x, y, w, h, data.preview_x, data.preview_y, data.scaleWidth, data.scaleHeight);
	}

	if(data.preview_r) ctx.restore();
};

window.Products.Product.prototype.render_texture = function(preview_data, designLab, imgLayers) {
	var ctx = designLab.textureCanvas_ctx;

	//Clear canvas and reset operation
	if(false && designLab.vectorManager.isEnabled()){
		if(imgLayers[0].name() == "scene-main"){
			ctx.clearRect(0, 0, preview_data.texture_width, preview_data.texture_height);
		}
	} else {
		ctx.fillStyle = "#ffffff";
		//ctx.fillRect(0, 0, preview_data.texture_width, preview_data.texture_height);
	}

	ctx.globalCompositeOperation = "source-over";

	if(this.textureCanvasPrepass){
		this.textureCanvasPrepass(ctx, imgLayers[0]?.scene || 'main', designLab.texture_resolution);
	}
	
	var omm = designLab.mirrorMode;

	//Draw each image
	for (j = 0; j < imgLayers.length; j++) {
		//Skip image if scene doesn't exist
		if(typeof preview_data.scenes[imgLayers[j].scene] === 'undefined')
			continue;

		var new_data;

		if(preview_data.scenes[imgLayers[j].scene].variants){
			scene_data = preview_data.scenes[imgLayers[j].scene].variants[designLab.variant];
		} else {
			scene_data = preview_data.scenes[imgLayers[j].scene];
		}

		//Set canvas pixel ratio
		//scene_data.canvasPixelRatio = designLab.stage.bufferCanvas.pixelRatio;

		//var img = imgLayers[j].getCanvas()._canvas;
		scene_data.canvasPixelRatio = 1;
		let img = imgLayers[j].canvas;

		designLab.mirrorMode = designLab.subproductMirrorModes[imgLayers[j].scene] 
			|| designLab.subproductMirrorModes[imgLayers[j].subproduct]
			|| designLab.subproductMirrorModes[imgLayers[j].subproduct+'-'+imgLayers[j].scene]
			|| 0;

		//Check for side mirror
		if(this.hasTool('mirror_side', preview_data, imgLayers[j].scene, designLab.variant)) {
			//Check for offset
			var mirrorOffset_x = preview_data.texture_width - scene_data.preview_x[1] - scene_data.preview_x[0];

			var y_offset = (Array.isArray(scene_data.preview_y)) ? scene_data.preview_y[0] - scene_data.preview_y[1] : 0;
			
			//Mirror Left side
			if(designLab.mirrorMode == 1) {
				// Calc x offset
				if(scene_data.cropWidth) {
					mirrorOffset_x -= (Array.isArray(scene_data.cropWidth)) ? scene_data.cropWidth[1] : scene_data.cropWidth;
				} else {
					mirrorOffset_x -= (Array.isArray(scene_data.scaleWidth)) ? scene_data.scaleWidth[1] : scene_data.scaleWidth;
				}

				//Left side
				this.draw_side(ctx, img, scene_data, 'left');

				//Right side (mirror from left)
				ctx.save();

				ctx.scale(-1,1);

				ctx.translate(-preview_data.texture_width + mirrorOffset_x, -y_offset);

				this.draw_side(ctx, img, scene_data, 'left');

				ctx.restore();
			} 
			//Mirror right side
			else if(designLab.mirrorMode == 2) {
				// Calc x offset
				if(scene_data.cropWidth) {
					mirrorOffset_x -= (Array.isArray(scene_data.cropWidth)) ? scene_data.cropWidth[0] : scene_data.cropWidth;
				} else {
					mirrorOffset_x -= (Array.isArray(scene_data.scaleWidth)) ? scene_data.scaleWidth[0] : scene_data.scaleWidth;	
				}

				//Left side (mirror from right side)
				ctx.save();

				ctx.scale(-1,1);

				ctx.translate(-preview_data.texture_width + mirrorOffset_x, y_offset);

				this.draw_side(ctx, img, scene_data, 'right');

				ctx.restore();

				//Right side
				this.draw_side(ctx, img, scene_data, 'right');
			}
			//Clone Left side
			else if(designLab.mirrorMode == 3) {
				//Left side
				this.draw_side(ctx, img, scene_data, 'left');

				//Right side (from left)
				ctx.save();

				if(this.static.rotate_fit){
					ctx.translate(preview_data.texture_width/2, preview_data.texture_height/2);
					ctx.scale(-1,-1);
					ctx.translate(-preview_data.texture_width/2, -preview_data.texture_height/2);
					
					if(scene_data.cropWidth) {
						ctx.translate(preview_data.texture_width - scene_data.preview_x[1] - scene_data.preview_x[0] - scene_data.cropWidth, preview_data.texture_height - scene_data.preview_y - scene_data.preview_y - scene_data.cropHeight);
					} else {
						ctx.translate(preview_data.texture_width - scene_data.preview_x[1] - scene_data.preview_x[0] - scene_data.scaleWidth, preview_data.texture_height - scene_data.preview_y - scene_data.preview_y - scene_data.scaleHeight);
					}
				} else {
					ctx.translate(scene_data.preview_x[1] - scene_data.preview_x[0], -y_offset); 
				}

				this.draw_side(ctx, img, scene_data, 'left');

				ctx.restore();
			} 
			//Clone right side
			else if(designLab.mirrorMode == 4) {
				//Left side (from right side)
				ctx.save();

				if(this.static.rotate_fit){
					ctx.translate(preview_data.texture_width/2, preview_data.texture_height/2);
					ctx.scale(-1,-1);
					ctx.translate(-preview_data.texture_width/2, -preview_data.texture_height/2);

					if(scene_data.cropWidth) {
						ctx.translate(preview_data.texture_width - scene_data.preview_x[1] - scene_data.preview_x[0] - scene_data.cropWidth, preview_data.texture_height - scene_data.preview_y - scene_data.preview_y - scene_data.cropHeight);
					} else {
						ctx.translate(preview_data.texture_width - scene_data.preview_x[1] - scene_data.preview_x[0] - scene_data.scaleWidth, preview_data.texture_height - scene_data.preview_y - scene_data.preview_y - scene_data.scaleHeight);
					}
				} else {
					ctx.translate(-scene_data.preview_x[1] + scene_data.preview_x[0], y_offset);
				}

				this.draw_side(ctx, img, scene_data, 'right');

				ctx.restore();

				//Right side
				this.draw_side(ctx, img, scene_data, 'right');
			} else {
				this.draw_side(ctx, img, scene_data, 'left');
				this.draw_side(ctx, img, scene_data, 'right');
			}
		}
		//Check for front mirror
		else {
			if(this.hasTool('mirror_front', preview_data, imgLayers[j].scene, designLab.variant) && designLab.mirrorMode !== 0) {
				//Mirror front: Only draw main scene and draw it mirrored on the back
				if(designLab.mirrorMode == 5) {
					//Skip back scene
					if(imgLayers[j].scene === 'back') {
						continue;
					}
					//front
					this.draw_scene(ctx, img, scene_data);

					//back
					//Change position and draw it
					new_data = Object.create(scene_data);
					new_data.preview_r = preview_data.scenes.back.preview_r || 0;

					//mirror it
					ctx.save();

					var main_cropWidth = preview_data.scenes.main.cropWidth ? preview_data.scenes.main.cropWidth : preview_data.scenes.main.scaleWidth,
						main_cropHeight = preview_data.scenes.main.cropHeight ? preview_data.scenes.main.cropHeight : preview_data.scenes.main.scaleHeight,
						back_cropWidth = preview_data.scenes.back.cropWidth ? preview_data.scenes.back.cropWidth : preview_data.scenes.back.scaleWidth,
						back_cropHeight = preview_data.scenes.back.cropHeight ? preview_data.scenes.back.cropHeight : preview_data.scenes.back.scaleHeight;

					var offsetX = this.static.mirror_from_center ? (main_cropWidth - back_cropWidth)/2 : 0,
						offsetY = this.static.mirror_from_center ? (main_cropHeight - back_cropHeight)/2 : 0;

					//Inverse x/y when dealing with 90 degrees rotation. Anything else than 90/180 isn't supported for mirrors
					if(Math.abs(new_data.preview_r) === 90) {
						ctx.scale(1,-1);
						ctx.translate(0, -preview_data.texture_height);
						new_data.preview_x = preview_data.scenes.back.preview_x - offsetY;
						new_data.preview_y = preview_data.texture_height - back_cropWidth - preview_data.scenes.back.preview_y - offsetX;
					} else {
						ctx.scale(-1,1);
						ctx.translate(-preview_data.texture_width, 0);
						new_data.preview_x = preview_data.texture_width - back_cropWidth - preview_data.scenes.back.preview_x - offsetX; //Position when mirrored
						new_data.preview_y = preview_data.scenes.back.preview_y - offsetY;
					}
					
					this.draw_scene(ctx, img, new_data);

					ctx.restore();
				} 

				//Mirror back: Only draw back scene and draw it mirrored on the front
				else if(designLab.mirrorMode == 6) {
					//Skip front scene
					if(imgLayers[j].scene === 'main') {
						continue;
					}

					//back
					this.draw_scene(ctx, img, scene_data);

					//front
					//mirror it
					ctx.save();
					ctx.scale(-1,1);
					ctx.translate(-preview_data.texture_width, 0);

					//Change position and draw it
					new_data = Object.create(scene_data);
					new_data.preview_r = preview_data.scenes.main.preview_r || 0;
					new_data.preview_x = preview_data.texture_width - preview_data.scenes.main.scaleWidth - preview_data.scenes.main.preview_x; //Position when mirrored
					new_data.preview_y = preview_data.scenes.main.preview_y;
					this.draw_scene(ctx, img, new_data);

					ctx.restore();
				}

				//Clone front: Only draw main scene and draw it to both sides
				else if(designLab.mirrorMode == 7) {
					//Skip back scene
					if(imgLayers[j].scene === 'back') {
						continue;
					}
					//front
					this.draw_scene(ctx, img, scene_data);

					//back
					//Change position and draw it
					new_data = Object.create(scene_data);
					new_data.preview_r = preview_data.scenes.back.preview_r || 0;

					//mirror it
					ctx.save();

					var main_cropWidth = preview_data.scenes.main.cropWidth ? preview_data.scenes.main.cropWidth : preview_data.scenes.main.scaleWidth,
						main_cropHeight = preview_data.scenes.main.cropHeight ? preview_data.scenes.main.cropHeight : preview_data.scenes.main.scaleHeight,
						back_cropWidth = preview_data.scenes.back.cropWidth ? preview_data.scenes.back.cropWidth : preview_data.scenes.back.scaleWidth,
						back_cropHeight = preview_data.scenes.back.cropHeight ? preview_data.scenes.back.cropHeight : preview_data.scenes.back.scaleHeight;

					var offsetX = this.static.mirror_from_center ? (main_cropWidth - back_cropWidth)/2 : 0,
						offsetY = this.static.mirror_from_center ? (main_cropHeight - back_cropHeight)/2 : 0;

					//Inverse x/y when dealing with 90 degrees rotation. Anything else than 90/180 isn't supported for mirrors
					if(Math.abs(new_data.preview_r) === 90) {
						new_data.preview_x = preview_data.scenes.back.preview_x - offsetY;
						new_data.preview_y = preview_data.scenes.back.preview_y - offsetX;
					} else {
						new_data.preview_x = preview_data.scenes.back.preview_x - offsetX; //Position when mirrored
						new_data.preview_y = preview_data.scenes.back.preview_y - offsetY;
					}

					this.draw_scene(ctx, img, new_data);
				} 

				//Clone back: Only draw back scene and draw it to both sides
				else if(designLab.mirrorMode == 8) {
					//Skip front scene
					if(imgLayers[j].scene === 'main') {
						continue;
					}

					//back
					this.draw_scene(ctx, img, scene_data);

					//front
					new_data = Object.create(scene_data);
					new_data.preview_r = preview_data.scenes.main.preview_r || 0;
					new_data.preview_x = preview_data.scenes.main.preview_x;
					new_data.preview_y = preview_data.scenes.main.preview_y;
					this.draw_scene(ctx, img, new_data);
				}
			} else {
				//Regular draw
				if(scene_data.deltax.length > 1 || scene_data.deltay.length > 1){
					this.draw_side(ctx, img, scene_data, 'left');
					this.draw_side(ctx, img, scene_data, 'right');
				} else {
					this.draw_scene(ctx, img, scene_data);
				}
			}
		}
	}

	if(this.textureCanvasPostpass){
		ctx.globalCompositeOperation = "destination-over";
		this.textureCanvasPostpass(ctx, designLab.modelViewer, imgLayers[0]?.scene || 'main', designLab.texture_resolution);
		ctx.globalCompositeOperation = "source-over";
	}

	designLab.mirrorMode = omm;

	if(this.bufferCanvas){
		ctx.drawImage(this.bufferCanvas, 0, 0);
		this.bufferCanvas.getContext('2d').clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
	}
};

window.Products.Product.prototype.updateThreeTexture = function(modelViewer) {
	//Abstract method
};

window.Products.Product.prototype.set3dProperties = function(modelViewer) {
	//Abstract method
};

window.Products.Product.prototype.setThreeControls = function(controls) {
	//Abstract method
};

window.Products.Product.prototype.setThreeView = function(camera, view, zoom) {
	if(!zoom) zoom = 0;
	switch(view) {
		case 'front':
			camera.position.z = -zoom;
			break;

		case 'left':
			camera.position.z = 0;
			camera.position.x = -zoom;
			break;

		case 'right':
			camera.position.z = 0;
			camera.position.x = zoom;
			break;

		case 'back': 
			camera.position.z = zoom;
			camera.position.x = 0;
			break;
	}
};

window.Products.Product.prototype.loadEnvMap = function(callback){
    var product = this;
    var source = 'textures/env1.jpg';

    var textureLoader = new THREE.TextureLoader();
    textureLoader.crossOrigin = 'anonymous';

    var texture = textureLoader.load(THREE_JSON_URL + source, function(event){
        product.envMap = event;
        if(callback) callback();
    });
};

window.Products.Product.prototype.rotationFromDistance = function(distance){
	return -0.0001672241 * distance + 0.3003344;
};

window.Products.Product.prototype.getDefaultScene = function(){
	return this.static.preview_data.default_scene || 'main';
};

window.Products.Product.prototype.getSaveId = function(){
	return this.static.saveId || this.static.id;
};

window.Products.Product.prototype.getOptions = function(){
	var editableOptions = this.getEditableOptions();
	var options = this.static.options;
	if(!options) return;

	var out = [];

	for(var option_type_slug in options){
		if(editableOptions.indexOf(option_type_slug) == -1) continue;

		var length = 0;

		for(var option_value_slug in options[option_type_slug].values)
			if(options[option_type_slug].values.hasOwnProperty(option_value_slug))
				length++;

		if(length > 2) {
			// Multiple choices, proceed as radio/thumb list
			out[option_type_slug] = $('#container_options_'+option_type_slug).find('input:checked').val();
		} else if(length == 2) {
			// Only two choices, proceed as checkbox
			var enabled = $('#container_options_'+option_type_slug).find('.switch').find('input').is(':checked');
			for(option_value_slug in options[option_type_slug].values){
				if(!options[option_type_slug].values.hasOwnProperty(option_value_slug)) continue;
				if(enabled) {
					out[option_type_slug] = option_value_slug;
					var extra = this.getOptionsExtra(option_type_slug);
					out = Object.assign({}, out, extra);
					break;
				} else enabled = !enabled;
			}
		} else {
			// 0/1 choices, can't process
			// - Not implemented yet
		}
	}

	return out;
};

window.Products.Product.prototype.getOptionThumb = function(_option){
	return IMG_URL + 'create/lab/options/' + _option + '.jpg';
};

window.Products.Product.prototype.getEditableOptions = function(){
	return [];
};

window.Products.Product.prototype.getEditableOptionsNames = function(){
	return [];
};

window.Products.Product.prototype.getEditableOptionsExtra = function(_option, _container){
	return '';
};

window.Products.Product.prototype.getOptionsExtra = function(_option){
	return [];
};

window.Products.Product.prototype.initOptions = function(){
	// Noop
};

window.Products.Product.prototype.handleOption = function(e){
	// Noop
};

// Most products will already have the correct obj
window.Products.Product.prototype.getObj = function(_currentObj) {
	return _currentObj;
};

window.Products.Product.prototype.getCustomVariant = function() {
	return null;
};

window.Products.Product.prototype.getColor = function(_name) {
	return null;
};

/*
const cache = {};

function importAll (r) {
  r.keys().forEach(key => cache[key] = r(key));
}

importAll(require.context('./', true, /\.js$/));
*/